
import shrink from '~/ZenOne-StoryBook/mixins/shrink'
import { API } from '~/ZenOne-StoryBook/config/api'
import { headers } from '~/ZenOne-StoryBook/config/auth'
import {
  getPrecision,
  getPrefix,
} from '~/components/dialog/dialog-shipping-terms/helper'

export default {
  name: 'DialogDistributorShippingTerms',
  mixins: [shrink],
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    distributor: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      fixedShippingCost: '',
      minOrderTotalFree: '',
      practiceLocationDistributorId: null,
      currencyFieldProperties: {
        height: 64,
      },
      commonCurrencyFieldOptions: {
        locale: 'en-US',
        suffix: '',
        length: 8,
      },
    }
  },
  computed: {
    currencyFieldOptions() {
      const { fixedShippingCost, minOrderTotalFree } = this
      return {
        shippingCost: {
          ...this.commonCurrencyFieldOptions,
          prefix: getPrefix(fixedShippingCost),
          precision: getPrecision(fixedShippingCost),
        },
        minOrderTotalFree: {
          ...this.commonCurrencyFieldOptions,
          prefix: getPrefix(minOrderTotalFree),
          precision: getPrecision(minOrderTotalFree),
        },
      }
    },
  },
  mounted() {
    this.fixedShippingCost = this.distributor.fixedShippingCost
    this.minOrderTotalFree = this.distributor.minOrderTotalFree
  },
  methods: {
    async onPatchSetting() {
      try {
        const id = this.distributor.practiceLocationDistributorId.toString()
        const fixedShippingCost = !this.fixedShippingCost ? null : parseFloat(this.fixedShippingCost)
        const minOrderTotalFree = !this.minOrderTotalFree ? null : parseFloat(this.minOrderTotalFree)

        await this.$axios.patch(`${API.PRACTICE_LOCATION_DISTRIBUTORS}/${id}`, {
          data: {
            type: `${API.PRACTICE_LOCATION_DISTRIBUTORS}`,
            id,
            attributes: {
              fixedShippingCost,
              minOrderTotalFree
            }
          }
        }, { headers })

        this.$emit('onRefreshDistributors')
        this.$emit('closeDialogShippingTerms')
      } catch (e) {
        console.error('Update distributor shipping terms error: ', e)
      }
    },
    onClose() {
      this.$emit('closeDialogShippingTerms')
    },
  },
}
